/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { metaMcpGet } from "../funcs/metaMcpGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { MetaMcpServer } from "../models/components/metamcpserver.js";
import {
  GetMetaMcpServerRequest,
  GetMetaMcpServerSecurity,
} from "../models/operations/getmetamcpserver.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMetaMcpServerQueryData = MetaMcpServer;

export function prefetchGetMetaMcpServer(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetMetaMcpServerRequest,
  security?: GetMetaMcpServerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMetaMcpServerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMetaMcpServerQuery(
  client$: GramCore,
  request: GetMetaMcpServerRequest,
  security?: GetMetaMcpServerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetMetaMcpServerQueryData>;
} {
  return {
    queryKey: queryKeyGetMetaMcpServer({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function getMetaMcpServerQueryFn(
      ctx,
    ): Promise<GetMetaMcpServerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(metaMcpGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMetaMcpServer(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "metaMcp", "get", parameters];
}
